/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-floating-promises */

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from "react";
import { API_URL } from "utils/constant";
import httpClient from "utils/apis/http-client";
import { showToast } from "utils/helper";
import { Button, Combobox, Input } from "@repo/ui";
import { useGetCashCenters, useGetOffices } from "utils/apis/lookups.api";

const apiUrl = API_URL;

const statusList = [
  {
    value: "Available",
    label: "Available",
  },
  {
    value: "Damaged",
    label: "Damaged",
  },
];

const assetTypes = [
  {
    value: "HHT",
    label: "HHT",
  },
  {
    value: "Cashbox",
    label: "Cashbox",
  },
  {
    value: "Printer",
    label: "Printer",
  },
  {
    value: "Pepper Spray",
    label: "Pepper Spray",
  },
];

function AddAssetCard({ onAssetAdded }: any) {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnUpdateText, setBtnUpdateText] = useState("Save");

  const [asset, setAsset] = useState({
    cashCenter: "",
    office: "",
    description: "",
    assetType: "",
    assetNo: "",
    serialNo: "",
    model: "",
    brand: "",
    status: "",
    remarks: "",
  });

  const [error, setError] = useState<any>({
    cashCenter: "",
    office: "",
    description: "",
    assetType: "",
    assetNo: "",
    status: "",
  });

  const { data: cashCenters } = useGetCashCenters();
  const { mutate: getOffices, data: offices } = useGetOffices();

  const onCashCentersChanged = (value: string) => {
    setAsset({ ...asset, cashCenter: value });
    if (!value) return;
    getOffices(value);
  };

  const addAsset = async () => {
    const obj = {
      cashCenterId: asset.cashCenter,
      officeId: asset.office,
      description: asset.description,
      assetType: asset.assetType,
      assetNo: asset.assetNo,
      serialNo: asset.serialNo,
      model: asset.model,
      brand: asset.brand,
      status: asset.status,
      remarks: asset.remarks,
    };

    setBtnDisabled(true);
    setBtnUpdateText("Adding Asset....");

    try {
      await httpClient
        .post(`${apiUrl}/resources/assets/add`, obj)
        .then((res) => {
          if (res.status === 200) {
            setBtnDisabled(false);
            setBtnUpdateText("Add Asset");
            setAsset({
              cashCenter: "",
              office: "",
              description: "",
              assetType: "",
              assetNo: "",
              serialNo: "",
              model: "",
              brand: "",
              status: "",
              remarks: "",
            });
            showToast("success", "Asset added successfully!");
            onAssetAdded();
          } else {
            setBtnDisabled(false);
            setBtnUpdateText("Save");
            showToast("error", "Failed to add asset , try again.");
          }
        });
    } catch (err) {
      setBtnDisabled(false);
      setBtnUpdateText("Save");
      showToast("error", "Failed to add asset , try again.");
    } finally {
      setBtnDisabled(false);
      setBtnUpdateText("Save");
      setBtnDisabled(false);
    }
  };

  const onBtnAddAssetClicked = () => {
    let errorCount = 0;

    const errorObj: any = {
      cashCenter: "",
      office: "",
      description: "",
      assetType: "",
      assetNo: "",
      status: "",
    };

    if (!asset.cashCenter) {
      errorCount++;
      errorObj.cashCenter = "indianred";
    }

    if (!asset.office) {
      errorCount++;
      errorObj.office = "indianred";
    }

    if (asset.description === "") {
      errorCount++;
      errorObj.description = "indianred";
    }

    if (!asset.assetType) {
      errorCount++;
      errorObj.assetType = "indianred";
    }

    if (asset.assetNo === "") {
      errorCount++;
      errorObj.assetNo = "indianred";
    }

    if (!asset.status) {
      errorCount++;
      errorObj.status = "indianred";
    }

    if (errorCount) {
      showToast("error", "Fields are required");
      setError(errorObj);
      return;
    }
    setError(errorObj);

    addAsset();
  };

  return (
    <>
      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.cashCenter}]`}>
            Cash Center
            <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            placeholder="Select Cash Center"
            data={cashCenters?.map((m: any) => ({
              value: m.cashCenterId,
              label: m.name,
            }))}
            value={asset.cashCenter}
            setValue={onCashCentersChanged}
          />
        </div>
        <div className="flex-1">
          <label className={`text-[${error.office}]`}>
            Office
            <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            placeholder="Select Office"
            data={offices?.map((m: any) => ({
              value: m.officeId,
              label: m.officeName,
            }))}
            value={asset.office}
            setValue={(e: string) => {
              setAsset({ ...asset, office: e });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.assetType}]`}>
            Asset Type
            <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            placeholder="Select Asset Type"
            data={assetTypes}
            value={asset.assetType}
            setValue={(e: string) => {
              setAsset({ ...asset, assetType: e });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-[${error.description}]`}>
            Description
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Asset Description"
            value={asset.description}
            onChange={(e) => {
              setAsset({ ...asset, description: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.assetNo}]`}>
            Asset No
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Asset No"
            value={asset.assetNo}
            style={{ borderColor: error.make }}
            onChange={(e) => {
              setAsset({ ...asset, assetNo: e.target.value });
            }}
          />
        </div>
        <div className="flex-1">
          <label>Serial No</label>
          <Input
            placeholder="Asset Serial No"
            value={asset.serialNo}
            onChange={(e) => {
              setAsset({ ...asset, serialNo: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label>Model</label>
          <Input
            placeholder="Asset Model"
            value={asset.model}
            onChange={(e) => {
              setAsset({ ...asset, model: e.target.value });
            }}
          />
        </div>
        <div className="flex-1">
          <label>Brand</label>
          <Input
            placeholder="Asset Brand"
            value={asset.brand}
            onChange={(e) => {
              setAsset({ ...asset, brand: e.target.value });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.status}]`}>
            <sup className="text-red-500">*</sup> Status
          </label>
          <Combobox
            placeholder="Select Status"
            data={statusList}
            value={asset.status}
            setValue={(e: string) => {
              setAsset({ ...asset, status: e });
            }}
          />
        </div>
        <div className="flex-1">
          <label>Remarks</label>
          <Input
            placeholder="Remarks"
            value={asset.remarks}
            onChange={(e) => {
              setAsset({ ...asset, remarks: e.target.value });
            }}
          />
        </div>
      </div>
      <div className="border-b my-3 bg-accent" />
      <Button
        className="w-[160px] flex ml-auto"
        variant="secondary"
        onClick={onBtnAddAssetClicked}
        disabled={btnDisabled}
      >
        {btnUpdateText}
      </Button>
    </>
  );
}

export default AddAssetCard;
